import type {FC} from 'react';
import {memo} from 'react';
import {useNavigate} from 'react-router';

import type {Button} from '@yourcoach/shared/uikit/Button';
import type {GetComponentProps} from '@yourcoach/shared/utils/utility-types';

import {useI18n} from '@yourcoach/i18n';
import LoginSVG from '@yourcoach/shared/assets/icons/primary/Login.svg';
import {Logo} from '@yourcoach/shared/uikit/Logo';
import {logger} from '@yourcoach/shared/utils/logger';
import {TestID} from '@yourcoach/shared/utils/test-utils/data-test-id';

import {routerPath} from '@src/routes/path';

import * as S from './styles';

interface Props {
  loginButtonText?: string;
}

const TopMenuPublic: FC<Props> = ({loginButtonText}) => {
  const navigate = useNavigate();
  const {t} = useI18n();

  const handleOnClick: GetComponentProps<typeof Button>['onClick'] = e => {
    e.event.DOMEvent?.preventDefault();
    e.event.DOMEvent?.stopPropagation();

    navigate(
      routerPath.login.$buildPath({}),
      routerPath.login.$buildState({
        state: {
          from: window.location.pathname,
          isFromPublicPage: true,
        },
      }),
    );

    logger.setUserProperty('came_from_public_link', 'yes');
  };

  return (
    <S.Container>
      <Logo size={40} variant="text" />
      <S.LoginButton
        icon={LoginSVG}
        onClick={handleOnClick}
        size="l"
        testID={TestID.menu.button.login_public}
      >
        {loginButtonText ?? t('shared:login_join')}
      </S.LoginButton>
    </S.Container>
  );
};

export default memo(TopMenuPublic);
